export const csRoute: { [key: string]: string } = {
  "/career": "/kariera",
  "/contact": "/kontakt",
  "/references": "/references",
  "/team": "/tym",
};
